/**
 * GPU and rendering capability detection utilities.
 * Used for graceful degradation when hardware acceleration is unavailable.
 */

let _webglSupported = null;
let _canvas2dSupported = null;
let _isAutomatedTest = null;

const isAutomatedTestEnvironment = () => {
  if (_isAutomatedTest !== null) return _isAutomatedTest;

  _isAutomatedTest = Boolean(
    navigator.webdriver ||
      window.__PLAYWRIGHT__ ||
      window.Cypress ||
      window.__nightmare ||
      document.documentElement.hasAttribute('webdriver') ||
      navigator.userAgent.includes('HeadlessChrome'),
  );
  return _isAutomatedTest;
};

const isWebGLSupported = () => {
  if (_webglSupported !== null) return _webglSupported;

  try {
    const canvas = document.createElement('canvas');
    const gl =
      canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
    _webglSupported = Boolean(gl);
  } catch (e) {
    _webglSupported = false;
  }
  return _webglSupported;
};

const isCanvas2DSupported = () => {
  if (_canvas2dSupported !== null) return _canvas2dSupported;

  try {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    _canvas2dSupported = Boolean(ctx);
  } catch (e) {
    _canvas2dSupported = false;
  }
  return _canvas2dSupported;
};

const shouldRenderThreeDimensionalView = () => {
  if (isAutomatedTestEnvironment()) return false;
  return isWebGLSupported();
};

const shouldRenderThreeSixtyView = () => {
  if (isAutomatedTestEnvironment()) return false;
  return isCanvas2DSupported();
};

const resetCapabilityCache = () => {
  _webglSupported = null;
  _canvas2dSupported = null;
  _isAutomatedTest = null;
};

export {
  isAutomatedTestEnvironment,
  isWebGLSupported,
  isCanvas2DSupported,
  shouldRenderThreeDimensionalView,
  shouldRenderThreeSixtyView,
  resetCapabilityCache,
};